<template>
  <div class="all-box auth-box">
    <div class="auth-wrap">
      <div class="auth-item-wrap">
        <p class="auth-items-icon">
          <img src="@/assets/author.png" style="object-fit: contain" />
        </p>
      </div>
      <div>
        <el-button round class="auth-submitBtn" @click="getBtnLogin"
          >一键登录</el-button
        >
      </div>
      <div class="auth-coypright">
        <el-checkbox v-model="checked">
          <span>阅读并同意</span>
          <a href="https://clubs.xinmin.cn/dzclub/yh.html" target="_blank"
            >《用户协议》</a
          >
          <span>和</span>
          <a href="https://clubs.xinmin.cn/dzclub/ys.html" target="_blank"
            >《隐私政策》</a
          >
        </el-checkbox>
      </div>
    </div>
    <div class="allDialog">
      <el-dialog
        title="用户协议及隐私政策"
        v-model="showDialog"
        width="70%"
        top="36vh"
        :show-close="false"
        center
      >
        <span
          ><span>请先阅读并同意</span>
          <a href="https://clubs.xinmin.cn/dzclub/yh.html" target="_blank"
            >《用户协议》</a
          >
          <span>和</span>
          <a href="https://clubs.xinmin.cn/dzclub/ys.html" target="_blank"
            >《隐私政策》</a
          >
        </span>
        <template #footer>
          <div class="dialog-footer">
            <el-button @click="showDialog = false">取 消</el-button>
            <el-button @click="getDialogLogin">确 定</el-button>
          </div>
        </template>
      </el-dialog>
    </div>
  </div>
</template>

<script>
export default {
  name: "auth",
  data() {
    return {
      redirect: null,
      wx: {
        uid: 0,
        openid: "",
        nickname: "",
        headimgurl: "",
        userToken: "",
      },
      code: "undefined",
      config: {
        wxOpenApiServer: "https://open.weixin.qq.com/connect/oauth2/authorize",
        appId: "wx77f07d59f891e7a5",
        localHref: "https://clubs.xinmin.cn/dzclub/index.html",
        openid: "xm",
      },
      showDialog: false,
      checked: false,
      fits: ["fill", "contain", "cover", "none", "scale-down"],
      storage: window.localStorage,
    };
  },
  created() {
    /** ✅ 修正：通过 this.$route.query 获取 redirect，而不是 location.search */
    const routeQuery = this.$route.query;
    this.redirect = routeQuery.redirect
      ? decodeURIComponent(routeQuery.redirect)
      : null;

    // 检查是否已登录
    const userToken = this.storage.getItem("usertoken");
    if (userToken) {
      if (this.redirect) {
        this.$router.replace(this.redirect);
      } else {
        this.$router.push({ name: "Home" });
      }
      return;
    }

    // 获取 code（兼容微信回调）
    this.code = routeQuery.code || this.getUrlCode().code;
    if (this.code) {
      this.getAuth();
    }
  },
  methods: {
    /** ✅ 微信授权回调 */
    getAuth() {
      this.checked = true;
      this.$axios
        .post("/wxindex/wxservice/getauth.html", {
          params: {
            code: this.code,
            state: this.config.openid,
          },
        })
        .then((response) => {
          if (response.data.status == true) {
            // 保存用户信息
            this.storage.setItem("uid", response.data.uid);
            this.storage.setItem("openid", response.data.openid);
            this.storage.setItem("nickname", response.data.nickname);
            this.storage.setItem("headimgurl", response.data.headimgurl);
            this.storage.setItem("usertoken", response.data.usertoken);

            // 清理 URL
            const cleanUrl =
              window.location.origin +
              window.location.pathname +
              window.location.hash;
            window.history.replaceState({}, document.title, cleanUrl);

            // 回跳页面
            if (this.redirect) {
              this.$router.replace(this.redirect);
            } else {
              this.$router.push({ name: "Home" });
            }
          } else {
            this.$router.push({ name: "Auth" });
          }
        });
    },

    /** ✅ 仅用于兼容微信 OAuth 回调时 URL 中带 ?code=xxx */
    getUrlCode() {
      const url = window.location.href;
      const queryString = url.split("?")[1];
      const theRequest = {};
      if (queryString) {
        const pairs = queryString.split("&");
        for (let i = 0; i < pairs.length; i++) {
          const [key, value] = pairs[i].split("=");
          theRequest[key] = value;
        }
      }
      return theRequest;
    },

    /** ✅ 微信网页授权触发 */
    getCode() {
      this.code = this.getUrlCode().code;
      if (!this.code) {
        // ✅ 获取当前 redirect 参数，传回微信授权回调地址
        const currentRedirect = this.$route.query.redirect || "";
        const redirectUrl = `${
          this.config.localHref
        }#/auth?redirect=${encodeURIComponent(currentRedirect)}`;

        // ✅ 拼接微信授权地址
        const wxAuthUrl = `${this.config.wxOpenApiServer}?appid=${
          this.config.appId
        }&redirect_uri=${encodeURIComponent(
          redirectUrl
        )}&response_type=code&scope=snsapi_userinfo&state=${
          this.config.openid
        }&connect_redirect=1#wechat_redirect`;

        window.location.href = wxAuthUrl;
      }
    },

    /** 按钮点击事件 */
    getBtnLogin() {
      if (this.checked) {
        this.getCode();
      } else {
        this.showDialog = true;
      }
    },
    getDialogLogin() {
      this.showDialog = false;
      this.checked = true;
      this.getCode();
    },
  },
};
</script>

<style scoped>
.auth-box {
  display: flex;
  position: relative;
  -webkit-flex-direction: column;
  flex-direction: column;
  -webkit-align-items: center;
  align-items: center;
  box-sizing: border-box;
  margin: auto;
  width: 100%;
  height: 100vh;
  background: url(~@/assets/authBg.png) no-repeat;
  background-size: cover;
}

.auth-wrap {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 0;
  right: 0;
  margin: auto;
  border-radius: 20px;
  width: 80%;
  background-color: var(--fff);
  box-shadow: 0 0 0 5px rgba(0, 0, 0, 0.1);
}

.auth-item-wrap {
  margin: 30% auto;
}

.auth-items-icon {
  width: 100px;
  margin: 0 auto 30px;
}

.auth-submitBtn {
  width: 70%;
  color: var(--fff);
  border: 1px solid var(--ee5f5c);
  background-color: var(--ee5f5c);
}

.auth-coypright {
  margin: 15px auto;
}

.auth-coypright span {
  color: var(--999);
  font-size: 12px;
}

.auth-coypright a {
  color: var(--333);
  font-size: 12px;
  text-decoration: none;
}

.allDialog span {
  color: var(--999);
}

.allDialog a {
  color: var(--333);
}
</style>